export default {
  namespaced: true,
  state: {
    autoChangeEndDate: false,
    payload: {
      selectedPeriod: 'consumptionperiod',
      start_date: '',
      end_date: '',
      uniqueDatesInPeriod: [],
      measures: [],
      title_codes: [],
    },
  },
  getters: {
    consumptionApiBody: state => state.payload,
  },
  mutations: {
    updatePeriod(state, newSelectedPeriod) {
      state.payload.selectedPeriod = newSelectedPeriod;
    },
    // Filter for reach measures
    updateMeasures(state, newMeasures) {
      const filteredMeasures = newMeasures.filter(measure => measure.isReach);
      // Remove duplicates based on genderAndAge and reachCriteriaText
      state.payload.measures = Array.from(
        filteredMeasures
          .reduce((map, measure) => {
            const key = `${measure.genderAndAge}-${measure.reachCriteriaText}`;
            if (!map.has(key)) {
              map.set(key, measure);
            }
            return map;
          }, new Map())
          .values(),
      );
    },

    updateStartDate(state, newStartDate) {
      state.payload.start_date = newStartDate;
    },
    updateEndDate(state, newEndDate) {
      state.payload.end_date = newEndDate;
    },
    updateAutoChangeEndDate(state, newAutoChangeEndDate) {
      state.autoChangeEndDate = newAutoChangeEndDate;
    },
    updateUniqueDatesInPeriod(state, newUniqueDatesInPeriod) {
      state.payload.uniqueDatesInPeriod = newUniqueDatesInPeriod;
    },
    setConsumptionApiBody(state, newSearchQuery) {
      state.payload = newSearchQuery;
    },
    updateTitleCodes(state, newTitleCodes) {
      state.payload.title_codes = newTitleCodes;
    },
  },
};
